<template>
    <BasicHeader v-if="credentialManager == 'aquacred'" pretitle="Sandbox Credential"
        :title="aquacredCredential ? aquacredCredential.name : ''" :buttonText="editMode ? 'Save' : ''"
        :buttonDisabled="saving || !validateCredential" :buttonLoading="saving" :buttonRoles="aquacredAllowedUserRoles"
        :ignoreButtonLift="true" buttonClass="btn-success" @btnClick="onSaveClick"
        :buttonText2="editMode ? 'Delete' : 'Edit'" :buttonClass2="editMode ? 'btn-danger' : 'btn-primary'"
        :buttonRoles2="aquacredAllowedUserRoles" @btnClick2="editMode ? onDeleteClick() : setEditMode(true)"
        :ignoreButtonLift2="true" :buttonIconClass3="editMode ? '' : 'fa fa-arrow-left me-1'"
        :buttonText3="editMode ? 'Cancel' : 'Back to Credentials list'"
        @btnClick3="editMode ? setEditMode(false) : onCancelClick()" :ignoreButtonLift3="true" />
    <BasicHeader v-else pretitle="Sandbox Credential" :title="credential ? credential.name : ''" buttonText="Detach"
        :buttonRoles="allowedUserRoles" :ignoreButtonLift="true" buttonClass="btn-danger" @btnClick="onDetachClick"
        buttonText2="Back to Credentials list" @btnClick2="onCancelClick" :buttonIconClass2="'fa fa-arrow-left me-1'" />
    <div class="container-fluid">
        <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
        <div v-if="credentialManager == 'aquacred'">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <FormFields :fields="credFields" v-model="aquacredCredential" :inlineField="true"
                                :editMode="editMode" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="credential">
                <div class="row">
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <FormFields :fields="fields" v-model="credValue" :inlineField="true"
                                    :editMode="false" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading" class="text-center">
            <div class="spinner-border">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>
<script>
import BasicHeader from '../../components/BasicHeader.vue';
import FormFields from '../../components/FormFields.vue';
import { mapActions, mapState } from 'vuex';
import { DateTimeFormat } from '../../utils/commonFunction';
import sandboxAquacredCredentials from '../../utils/field-constants/sandboxAquacredCredentials.js';
export default {
    name: "SandoxCredential",
    components: { BasicHeader, FormFields },
    data() {
        return {
            credValue: {},
            credential: {},
            error: null,
            loading: false,
            sandboxCredential: {},
            fields: [],
            allowedUserRoles: [1, 1.5], //aqfer admin, aqfer manager can detach credential to sandbox

            aquacredCredential: {},
            snapshot: {}, // to store original credential details when edit mode is enabled, so that we can revert back if user cancel the edit
            sandboxCredFields: JSON.parse(JSON.stringify(sandboxAquacredCredentials)),
            editMode: false,
            saving: false,
            aquacredAllowedUserRoles: [1, 1.5, 3], //aqfer admin, aqfer manager or client admin can view aquacred credentials
            requiredFields: {
                aqfer: ['refresh_token'],
                aws: ['access_key', 'secret_key'],
                gcp: ['project_id', 'private_key_id', 'private_key', 'client_email', 'client_id', 'auth_uri', 'token_uri', 'auth_provider_x509_cert_url', 'client_x509_cert_url'],
            },
        }
    },
    async beforeMount() {
        if (this.credentialManager == 'aquacred') {
            if (this.$route.params.data) {
                this.aquacredCredential = JSON.parse(this.$route.params.data);
            } else {
                await this.refreshAquacredCredentials();
                const aquacredCredentials = this.aquacredSandboxCredentials || [];
                this.aquacredCredential = aquacredCredentials.find(cred => cred.name === this.$route.params.id) || {};
                this.aquacredCredential.type = this.getCredentialType(this.aquacredCredential);
            }
            this.maskSensitiveFields();
        } else {
            this.fetchCredential();
            this.fetchSandboxCredential();
        }
    },
    watch: {
        credential() {
            //Setting default fields and value
            let fields = [{
                name: "sandboxName",
                type: "text",
                label: "Sandbox Name"
            },
            {
                name: "credentialName",
                type: "text",
                label: "Credential Name"
            },
            {
                name: "credentialType",
                type: "text",
                label: "Credential Type"
            }
            ];
            let credValue = {
                sandboxName: this.$route.params.sandboxId,
                credentialType: this.credential.type,
                credentialName: this.credential.name
            }
            if (this.credential.fields) {
                this.credential.fields.map((field) => {
                    if (field.type == "url")
                        credValue[field.name] = field.value !== '' ? "***********" : '';
                    else credValue[field.name] = field.value;
                    fields.push({
                        name: field.name,
                        type: "text",
                        label: field.name,
                        placeholder: field.description
                    })
                })
            }
            //these values will be only if navigate from list
            if (this.sandboxCredential.attached_by) {
                fields.push({
                    name: "attached_by",
                    type: "text",
                    label: "Attached By"
                },
                    {
                        name: "attached_at",
                        type: "text",
                        label: "Attached at"
                    })
                credValue["attached_by"] = this.sandboxCredential.attached_by;
                credValue["attached_at"] = DateTimeFormat(this.sandboxCredential.attached_at);
            }
            this.credValue = credValue
            this.fields = fields
        }
    },
    computed: {
        ...mapState({
            sandboxDetails: state => state.sandbox.sandboxDetails,
            sandboxCredentials: state => state.amdp.sandboxCredentials,
            aquacredSandboxCredentials: state => state.amdp.aquacredSandboxCredentials,
            selectedSandbox: state => state.sandbox.currentSandbox,
        }),
        credentialManager() {
            return this.sandboxDetails[this.selectedSandbox]?.credential_manager || 'lakeview';
        },
        credFields() {
            let fields = this.sandboxCredFields.map((field) => {
                return {
                    ...field,
                    visible: field.filterByType.includes(this.aquacredCredential.type)
                };
            });
            return fields;
        },
        validateCredential() {
            if (!this.aquacredCredential || !this.aquacredCredential.type) return false;
            let requiredFields = this.requiredFields[this.aquacredCredential.type] || [];
            if (!requiredFields || requiredFields.length === 0) return true;
            return requiredFields.every(field => this.aquacredCredential[field]);
        },
    },
    methods: {
        ...mapActions({
            readCredential: "amdp/readCredential",
            upsertSandboxCredential: "amdp/upsertSandboxCredential",
            fetchAquacredCredentials: "amdp/fetchAquacredCredentials",
            showModal: "showModal",
            deleteAquacredCredentials: "amdp/deleteAquacredCredentials",
            updateAquacredCredential: "amdp/upsertAquacredCredential",
        }),

        // ── aquacred actions ─────────────────────────────────────────────────

        setEditMode(value) {
            this.editMode = value;
            if (value) {
                // take a snapshot of original data
                this.snapshot = JSON.parse(JSON.stringify(this.aquacredCredential));

                // clear sensitive fields so user must re-enter them
                const sensitiveFields = ['refresh_token', 'access_key', 'secret_key', 'session_token', 'private_key'];
                sensitiveFields.forEach(f => {
                    if (this.aquacredCredential[f]) this.aquacredCredential[f] = '';
                });
            } else {
                // restore the snapshot with edited data
                this.aquacredCredential = JSON.parse(JSON.stringify(this.snapshot));
                this.maskSensitiveFields();
            }
        },
        maskSensitiveFields() {
            const sensitiveFields = ['refresh_token', 'access_key', 'secret_key', 'session_token', 'private_key'];
            sensitiveFields.forEach(f => {
                if (this.aquacredCredential[f]) this.aquacredCredential[f] = '***********';
            });
        },
        getCredentialType(credential) {
            let keys = Object.keys(credential || {});
            if (keys.length > 0) {
                if (keys.includes('refresh_token')) {
                    return "aqfer";
                } else if (keys.includes('access_key') && keys.includes('secret_key')) {
                    return "aws";
                } else {
                    return "gcp";
                }
            }
            return null;
        },
        async onSaveClick() {
            this.saving = true;
            try {
                let cred = this.aquacredCredential;
                let payload = {
                    name: cred.name,
                    type: cred.type,
                }
                this.credFields.map((field) => {
                    if (field.visible && cred[field.name]) {
                        payload[field.name] = cred[field.name];
                    }
                });
                await this.updateAquacredCredential({
                    service: 'amdp',
                    namespace: this.$route.params.sandboxId || this.selectedSandbox,
                    credentialName: cred.name,
                    payload: payload
                });
                this.$store.dispatch('addToast', {
                    message: "Credential updated successfully.",
                    type: 'success'
                });

                // refresh credentials list and snapshot
                await this.refreshAquacredCredentials();
                const aquacredCredentials = this.aquacredSandboxCredentials || [];
                this.aquacredCredential = aquacredCredentials.find(cred => cred.name === this.$route.params.id) || {};
                this.aquacredCredential.type = this.getCredentialType(this.aquacredCredential);
                this.snapshot = JSON.parse(JSON.stringify(this.aquacredCredential));

                // exit edit mode
                this.setEditMode(false);
            } catch (error) {
                let err = error?.response?.data?.error || error?.message;
                console.error(err);
                this.$store.dispatch('addToast', {
                    message: "Something went wrong while updating credential. Please contact support.",
                    type: 'error'
                });
            } finally {
                this.saving = false;
            }
        },
        onDeleteClick() {
            let self = this;
            let credName = this.aquacredCredential.name;
            this.showModal({
                component: "confirm",
                data: {
                    title: "Delete Credential",
                    message: `Are you sure you want to <strong class="text-danger">DELETE</strong> the credential - <strong>${credName}</strong>?`,
                    confirmText: 'Delete',
                    confirmClass: 'btn-danger',
                    cancelText: 'Cancel',
                    cancelClass: 'btn-secondary',
                    async confirm() {
                        try {
                            await self.deleteAquacredCredentials({
                                service: 'amdp',
                                namespace: self.$route.params.sandboxId || self.selectedSandbox,
                                credentialName: credName
                            });
                            self.$store.dispatch('addToast', {
                                message: "Credential deleted successfully.",
                                type: 'success'
                            });
                            self.onCancelClick();
                        } catch (error) {
                            let err = error?.response?.data?.error || error?.message;
                            console.error(err);
                            self.$store.dispatch('addToast', {
                                type: 'error',
                                message: "Something went wrong while deleting credential. Please contact support.",
                            });
                        }
                    }
                }
            });
        },
        async refreshAquacredCredentials() {
            this.loading = true;
            await this.fetchAquacredCredentials({
                service: 'amdp',
                namespace: this.selectedSandbox
            }).finally(() => {
                this.loading = false;
            });
        },

        // ── lakeview actions ─────────────────────────────────────────────────

        async fetchCredential() {
            let response = {}
            this.loading = true
            try {
                response = await this.readCredential(this.$route.params.id);
            } catch (error) {
                if (error.response.data)
                    this.error = error.response.data.error;
                else this.error = error.message;
                return;
            } finally {
                this.loading = false;
            }
            this.credential = await response.data;

        },
        async fetchSandboxCredential() {
            if (this.$route.params.data)
                this.sandboxCredential = JSON.parse(this.$route.params.data);
        },
        onDetachClick() {
            const self = this;
            let toastoptions;
            this.showModal({
                component: "confirm",
                data: {
                    title: "Detach Credential",
                    message: `Are you sure you want to detach the credential ${this.credValue.credentialName} from ${this.credValue.sandboxName} ?`,
                    async confirm() {
                        try {
                            await self.upsertSandboxCredential({ sandboxName: self.credValue.sandboxName, payload: { "remove_credentials": [self.credValue.credentialName] } });
                            toastoptions = {
                                message: "Sandbox Credentials detached successfully.",
                                type: "success"
                            }
                        } catch (error) {
                            this.error = error.message;
                            toastoptions = {
                                message: "Something went wrong when detaching sandbox credential. Please contact support."
                            }
                        } finally {
                            self.$store.dispatch("hideModal");
                            self.$store.dispatch("sandbox/setCurrentSandbox", self.credValue.sandboxName);
                            self.$store.dispatch('addToast', toastoptions);
                            self.onCancelClick()
                        }
                    }

                }
            })
        },
        onCancelClick() {
            this.$router.push({ name: "Sandbox Credentials" });
        }
    }
}
</script>
<style></style>